import { useCallback, useMemo } from 'react';
import {
  Notification,
  NotificationStatus,
  useUpdateNotification,
} from 'src/graphql/entities/notification';
import { getNotificationScopeConditions } from './use-notification-menu-items';

export const useInboxMenuItems = () => {
  const { updateNotificationsByCondition } = useUpdateNotification();

  const markOneAsRead = useCallback(
    (notification: Notification) => {
      // mark unread notifications in the same scope (entity or single record).
      updateNotificationsByCondition({
        conditions: [
          ...getNotificationScopeConditions(notification),
          { attribute: 'status', operator: '=', value: NotificationStatus.Unread },
        ],
        patch: { status: NotificationStatus.Read },
      });
    },
    [updateNotificationsByCondition],
  );

  const markAllAsRead = useCallback(() => {
    updateNotificationsByCondition({
      conditions: [{ attribute: 'status', operator: '=', value: NotificationStatus.Unread }],
      patch: { status: NotificationStatus.Read },
    });
  }, [updateNotificationsByCondition]);

  const markAllAsArchived = useCallback(() => {
    updateNotificationsByCondition({
      conditions: [
        { attribute: 'status', operator: '!=', value: NotificationStatus.Archived },
      ],
      patch: { status: NotificationStatus.Archived },
    });
  }, [updateNotificationsByCondition]);

  const markReadAsArchived = useCallback(() => {
    updateNotificationsByCondition({
      conditions: [{ attribute: 'status', operator: '=', value: NotificationStatus.Read }],
      patch: { status: NotificationStatus.Archived },
    });
  }, [updateNotificationsByCondition]);

  const menuItems = useMemo(() => {
    return [
      {
        label: 'Mark all as read',
        onClick: markAllAsRead,
      },
      {
        label: 'Archive read',
        onClick: markReadAsArchived,
      },
      {
        label: 'Archive all',
        onClick: markAllAsArchived,
      },
    ];
  }, [markAllAsRead, markReadAsArchived, markAllAsArchived]);

  return {
    markOneAsRead,
    markAllAsRead,
    markAllAsArchived,
    markReadAsArchived,
    menuItems,
  };
};
